import React from 'react'
import { useNavigate } from 'react-router-dom'
import RemarksSubNav from './components/RemarksSubNav'
import RemarksTable from './components/RemarksTable'
import SharedFilters from '../../components/SharedFilters'
import PredefinedReportsDrawer from '../../components/PredefinedReportsDrawer'
import useRemarksList from './hooks/useRemarksList'

export default function RemarksListScreen() {
  const navigate = useNavigate()
  const { state, actions } = useRemarksList()

  const toolsConfig = [
    { key: 'print-report', label: 'Print Report', icon: 'print' }
  ]

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-20">
      {/* ── Top Canopy: Header & SubNav ── */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">
            Student Discipline &amp; Feedback
          </p>
          <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-on-surface">
            Student Remarks Management
          </h1>
          <p className="mt-0.5 text-xs text-on-surface-variant">
            Log, track, and dispatch behavioral remarks, faculty notes, academic observations, and parental updates.
          </p>
        </div>

        {/* <div className="flex items-center gap-3">
          <RemarksSubNav />
          <button
            type="button"
            onClick={() => navigate('/remarks/entry')}
            className="flex items-center gap-1.5 rounded-xl bg-primary px-4 py-2 text-xs font-extrabold text-on-primary shadow-xs hover:bg-primary/90 transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-base">add</span>
            <span>New Remark</span>
          </button>
        </div> */}
      </section>

      {/* ── Shared Filter Accordion & Tools ── */}
      <SharedFilters
        searchField={state.searchField}
        searchText={state.searchText}
        companyFilter={state.companyFilter}
        branchFilter={state.branchFilter}
        courseFilter={state.courseFilter}
        academicYearFilter={state.academicYearFilter}
        batchFilter={state.batchFilter}
        fromDate={state.fromDate}
        tillDate={state.tillDate}
        setSearchField={actions.setSearchField}
        setSearchText={actions.setSearchText}
        setCompanyFilter={actions.setCompanyFilter}
        setBranchFilter={actions.setBranchFilter}
        setCourseFilter={actions.setCourseFilter}
        setAcademicYearFilter={actions.setAcademicYearFilter}
        setBatchFilter={actions.setBatchFilter}
        setFromDate={actions.setFromDate}
        setTillDate={actions.setTillDate}
        onReset={actions.handleResetFilters}
        onSearch={() => { }}
        searchFieldOptions={state.options.searchFields}
        companyOptions={state.options.companies}
        branchOptions={state.options.branches}
        courseOptions={state.options.courses}
        batchOptions={state.options.batches}
        academicYearOptions={state.options.academicYears}
        visibleAccordionFilters={[
          'company',
          'branch',
          'course',
          'academicYear',
          'batch',
          'dateRange',
        ]}
        tools={toolsConfig}
        onToolSelect={(key) => {
          if (key === 'new-entry') {
            navigate('/remarks/entry')
          } else if (key === 'print-report') {
            actions.setIsReportsOpen(true)
          } else if (key === 'export-excel') {
            actions.handleExportExcel()
          }
        }}
      />

      {/* ── Remarks Data Table ── */}
      <RemarksTable
        records={state.records}
        loading={state.loading}
        sortBy={state.sortBy}
        sortOrder={state.sortOrder}
        onSort={actions.handleSort}
        onDelete={actions.handleDelete}
        onSendSms={actions.handleSendSms}
        onSendWhatsApp={actions.handleSendWhatsApp}
      />

      {/* ── Predefined Reports Drawer ── */}
      <PredefinedReportsDrawer
        isOpen={state.isReportsOpen}
        onClose={() => actions.setIsReportsOpen(false)}
        title="Student Remarks Reports"
        moduleLabel="Remarks"
      />
    </div>
  )
}
